import React, { useContext } from 'react'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'
import Stack from '@mui/material/Stack'
import { Button, Grid, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'

import ViewActivities from 'components/ParticipantProfile/ViewActivities'
import SignupFormWrapper from 'components/ParticipantProfile/SignupFormWrapper'
import ParticipantCard from 'components/ParticipantProfile/ParticipantCard'
import TabPanel from 'components/Shared/TabPanel'
import Tab from 'components/Shared/Tab'
import { participantProfileTabs } from 'lib/participants/Constants'
import ViewNotes from 'components/ParticipantProfile/ViewNotes'
import { ParticipantProfileContext } from 'containers/ParticipantProfile'
import { useAppSelector } from 'redux/Hook'
import AlleySpacer from 'components/Shared/AlleySpacer'

const ParticipantProfileTab = () => {
  const { participantSummary } = useContext(ParticipantProfileContext).state

  const { search } = useLocation()

  // if there is no query param named edit then readonly mode else should be editable
  const readOnlyMode = new URLSearchParams(search).get('edit') === null

  const [activeTabIndex, setActiveTabIndex] = React.useState(0)

  const handleChangeTab = (event: React.SyntheticEvent, tabIndex: number) => {
    setActiveTabIndex(tabIndex)
  }

  const { t } = useTranslation()

  const navigate = useNavigate()

  const addEditParam = () => {
    navigate('?edit=true')
  }

  const renderEditButton = () => {
    if (readOnlyMode && participantSummary.signupFormResponse) {
      return (
        <Button data-cy="edit-participant" onClick={addEditParam}>
          {t('common.edit')}
        </Button>
      )
    }
  }

  const renderNoProfileDetails = () => {
    return (
      <>
        <Typography textAlign="center">
          {t('participant.tabs.noProfileDetails')}
        </Typography>
      </>
    )
  }

  const { answers } = useAppSelector((state) => state.signupAnswers)

  const isSignupAnswersPresent = Object.keys(answers).length !== 0

  const renderSignupForm = () => {
    if (isSignupAnswersPresent) {
      return <SignupFormWrapper />
    }
    return renderNoProfileDetails()
  }

  return (
    <>
      <ParticipantCard>
        <Stack spacing={3}>
          <Box borderBottom={1} borderColor="divider">
            <Tab
              activeTabIndex={activeTabIndex}
              handleChangeTab={handleChangeTab}
              a11ylabel={t('participant.tabs.ariaLabel')}
              a11yPropsKey={t('participant.tabs.accesibilityPropsKey')}
              items={participantProfileTabs}
            />
          </Box>
          <TabPanel value={activeTabIndex} index={0} name="participant-profile">
            <Grid container columns={{ xs: 8, sm: 12 }}>
              <Grid item xs={8} sm={8}>
                <Stack
                  direction={readOnlyMode ? 'row' : 'column'}
                  spacing={4}
                  justifyContent="space-between"
                >
                  <Typography variant="h5">
                    {t('participant.profile.signup.heading')}
                  </Typography>
                  {renderEditButton()}
                </Stack>
                <AlleySpacer spacing={1} direction={'top'}>
                  {renderSignupForm()}
                </AlleySpacer>
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel
            value={activeTabIndex}
            index={1}
            name="participant-activities"
            data-testid="activities-tab"
          >
            <ViewActivities />
          </TabPanel>
          <TabPanel
            value={activeTabIndex}
            index={2}
            name="participant-notes"
            data-testid="notes-tab"
          >
            <ViewNotes />
          </TabPanel>
        </Stack>
      </ParticipantCard>
    </>
  )
}

export default ParticipantProfileTab
